export default __webpack_public_path__ + "static/media/15060-miltman.0316d0f2.pdf";